export default __webpack_public_path__ + "static/media/user-logout-red.24848888.svg";